(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();


/* =========================================================
   SETTY — Smooth scroll reveal motion
   Added only for scroll animation. No layout/theme behavior changes.
========================================================= */
(function settySmoothMotion() {
  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var main = document.getElementById('MainContent');
    if (!main || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('setty-motion-ready');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('setty-reveal--visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -7% 0px'
    });

    function bind(el, type, delay) {
      if (!(el instanceof HTMLElement) || el.dataset.settyRevealBound === 'true') return;
      el.dataset.settyRevealBound = 'true';
      el.classList.add('setty-reveal', 'setty-reveal--' + type);
      el.style.setProperty('--setty-reveal-delay', Math.min(delay || 0, 320) + 'ms');
      observer.observe(el);
    }

    function bindSection(section, sectionIndex) {
      if (!(section instanceof HTMLElement) || section.dataset.settySectionBound === 'true') return;
      section.dataset.settySectionBound = 'true';

      var marker = ((section.id || '') + ' ' + (section.className || '')).toLowerCase();
      if (marker.indexOf('loader') === -1) {
        if (sectionIndex === 0) {
          section.classList.add('setty-reveal', 'setty-reveal--section', 'setty-reveal--visible');
          section.dataset.settyRevealBound = 'true';
        } else {
          bind(section, 'section', 0);
        }
      }

      var cards = section.querySelectorAll([
        '.product-card',
        '.card',
        '.resource-card',
        '.collection-card',
        '.collection-links__link',
        '[class*="product-card"]',
        '[class*="collection-card"]'
      ].join(','));

      Array.prototype.forEach.call(cards, function (card, i) {
        if (card.closest('dialog, [role="dialog"], .drawer, [class*="drawer"], [class*="modal"]')) return;
        bind(card, 'card', (i % 6) * 45);
      });

      var media = section.querySelectorAll([
        '.hero__media',
        '.media-block__media',
        '.image-with-text__media',
        '.collection-links__image',
        '.resource-card__media',
        '[class*="banner"] [class*="media"]'
      ].join(','));

      Array.prototype.forEach.call(media, function (item, i) {
        if (item.closest('.setty-reveal--card, dialog, [role="dialog"], .drawer, [class*="drawer"], [class*="modal"]')) return;
        bind(item, 'media', Math.min(i * 55, 180));
      });

      var copy = section.querySelectorAll('h1, h2, h3');
      Array.prototype.forEach.call(copy, function (item, i) {
        if (item.closest('.setty-reveal--card, dialog, [role="dialog"], .drawer, [class*="drawer"], [class*="modal"]')) return;
        bind(item, 'copy', Math.min(i * 45, 180));
      });
    }

    function bindAll() {
      var sections = Array.prototype.filter.call(main.children, function (node) {
        return node instanceof HTMLElement;
      });
      sections.forEach(function (section, i) { bindSection(section, i); });
    }

    bindAll();

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target instanceof HTMLElement ? event.target : null;
      if (section) bindSection(section, -1);
    });

    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.parentElement === main) bindSection(node, -1);
        });
      });
    });
    mutationObserver.observe(main, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/* ===== END SETTY SMOOTH MOTION ===== */
